import $ from "jquery";
import api from "./data/ajax";

const checkoutapplycoupon = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      anchorTop: "#anchor_top",
      input: "#js-checkout-apply-coupon",
      codecupon: "#coupon_code",
      btnSubmit: ".woocommerce-form-coupon button[name='apply_coupon']",
      newBtnSubmit: ".js-checkout-apply-coupon__button",
    };

    if ($(el.input).length === 0) return;

    $(document).on("input", el.input, function (e) {
      e.preventDefault();

      $(el.codecupon).val($(this).val());
    });

    $(document).on("blur", el.input, function () {
      const coupon_code = $(this).val();
      const type_tax = $(
        "#myparcel-delivery-options__deliveryMoment--evening"
      ).is(":checked")
        ? "evening"
        : "standard";

      if ($(this).val() == "") return;

      api
        .apply_coupon(coupon_code, {
          type_tax: type_tax,
          is_remove: "0",
        })
        .done((res) => {
          const fragments = res.fragments;

          $.each(fragments, (key, value) => {
            $(key).html(value);
          });
        })
        .catch((xhr) => {
          // eslint-disable-next-line no-console
          console.log("Err:", xhr.responseJSON);
        });

      $(this).val("");

      $(el.newBtnSubmit).trigger("click");
      $(el.anchorTop)[0].scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    });

    $(document).on("keydown", el.input, function (e) {
      if (e.key === "Enter") {
        event.preventDefault();
        const coupon_code = $(this).val();
        const type_tax = $(
          "#myparcel-delivery-options__deliveryMoment--evening"
        ).is(":checked")
          ? "evening"
          : "standard";

        if ($(this).val() == "") return;

        api.apply_coupon(coupon_code, {
          type_tax: type_tax,
          is_remove: "0",
        })
          .done((res) => {
            const fragments = res.fragments;

            $.each(fragments, (key, value) => {
              $(key).html(value);
            });
          })
          .catch((xhr) => {
            // eslint-disable-next-line no-console
            console.log("Error:", xhr.responseJSON);
          });

        $(this).val("");

        $(el.newBtnSubmit).trigger("click");
        $(el.anchorTop)[0].scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    });

    $(document).on("keypress", el.input, function (e) {
      const keycode = e.originalEvent.key;
      if (keycode !== "Enter") return;
      $(el.newBtnSubmit).trigger("click");
      // $(this).val("");
      $(el.anchorTop)[0].scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    });
  };

  init();
};

try {
  checkoutapplycoupon();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
